import { Component, Host, h, Prop } from '@stencil/core'
import { NOTIFICATION } from '@local/models'
import CircleInfo from '../../icons/svg/circle-info.svg'
import CircleCheck from '../../icons/svg/circle-check.svg'
import CircleExclamation from '../../icons/svg/circle-exclamation.svg'
import CircleMinus from '../../icons/svg/circle-minus.svg'


@Component({
  tag: 'cr-notification',
  styleUrl: 'cr-notification.css',
  shadow: true,
})
export class CrNotification {

  /**
   * The type of notification. Determines appearance
   * @type {string | NOTIFICATION}
   */
  @Prop() type: NOTIFICATION = NOTIFICATION.INFO

  render() {
    return (
      <Host>
        <div class={`notification ${this.type}`}>
            { this.type === NOTIFICATION.INFO ? <div class={`details ${this.type}`} innerHTML={CircleInfo}></div> : null }
            { this.type === NOTIFICATION.SUCCESS ? <div class={`details ${this.type}`} innerHTML={CircleCheck}></div> : null }
            { this.type === NOTIFICATION.WARN ? <div class={`details ${this.type}`} innerHTML={CircleExclamation}></div> : null }
            { this.type === NOTIFICATION.ERROR ? <div class={`details ${this.type}`} innerHTML={CircleMinus}></div> : null }
          <div class="text-wrapper"><slot></slot></div>
        </div>
      </Host>
    );
  }

}
